import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SchedulePage.css';

export default function SchedulePage() {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <main className="schedule-page">
      <div className="schedule-shell">
        <div className="schedule-top">
          <Link className="schedule-back" to="/">
            ← Back to site
          </Link>
        </div>

        <div 
          className="calendly-inline-widget" 
          data-url="https://calendly.com/dan-auradrobe" 
          style={{ minWidth: '320px', height: '700px' }}
        />
      </div>
    </main>
  );
}

